// extracted by mini-css-extract-plugin
export default {"header":"SimpleHeader_header__ZfMXK"};